



























































































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, reactive, SetupContext } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Template = {
  id: string,
  name: string,
  created_at: string,
  updated_at: string,
  organization_id: string,
  is_vertical: boolean,
  has_description: boolean,
  has_image: boolean,
  has_spec: boolean,
}

type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,    
	updated_at: string,  
}

type Props = {
  id: string;
};

export default defineComponent({
  name: "ProjectEditor",
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: "stylesheet", type: "text/css", href: "/css/login/project.css" }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" },
      { src: "/js/project.js" }
    ]
  },
  setup(props: Props, context: SetupContext) {
    const state = reactive({
      project: {} as Project,
      templates: [] as Template[],
      selected_template_id: ''
    });

    const nameCount = computed(() => {
      return state.project.name.length;
    });
    const memoCount = computed(() => {
      return state.project.supplemental_memo.length;
    });

    async function load() {
      console.log(props)
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.get('dev', '/projects/' + props.id, options).then(response => {
        console.log(response);
        state.project = response.data;
        console.log(state);
      }).catch(err => {
        console.log(err);
      });
    }
    load();


    async function listTemplates() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.get('dev', '/cptemplates', options).then(response => {
        console.log(response);
        state.templates = response.data;
        if (state.templates !== null && state.templates.length > 0) {
          state.selected_template_id = state.templates[0].id;
        }
        console.log(state);
      }).catch(err => {
        console.log(err);
      });
    }
    listTemplates();

    async function updateProject() {
      // NOTE: 何故か v-model へ直接 state.project.default_cp_template_id を指定すると
      // ラジオボタンが正しく動作しないため、別変数を一旦経由する。
      state.project.default_cp_template_id = state.selected_template_id;
      console.log(state.project);

      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        body: state.project
      }

      console.log(state.project);

      API.put('dev', '/projects', options).then(response => {
        console.log(response);
        context.root.$router.push({ name: 'ProjectDetail', params: { id: response.data.id } });
      }).catch(err => {
        console.log(err);
      });
    }

    return {
      state,
      nameCount,
      memoCount,
      updateProject,
    };
  }
});
